// extracted by mini-css-extract-plugin
module.exports = {"formWrapper":"ApproverForm_formWrapper__2ef7a","fieldWrap":"ApproverForm_fieldWrap__1Wfb2","approveBtn":"ApproverForm_approveBtn__3RnqY"};